import styles from "./CreateAlbumPictureSquare.module.css";

export const CreateAlbumPictureSquare = ({ picture = null, removeByID }) => {
  if (picture) {
    console.log(picture.id);
  }
  return (
    <>
      <div className={styles.album_single_square_picture_div}>
        {picture && (
          <img
            style={{ maxHeight: "200px", maxWidth: "200px" }}
            src={URL.createObjectURL(picture)}
            alt={picture.name}
          />
        )}
        {picture && (
          <div
            onClick={() => removeByID(picture.id)}
            className={styles.album_single_square_cross_div}
          >
            <ion-icon
              className={styles.album_single_square_cross_icon}
              name="close"
            ></ion-icon>
          </div>
        )}
      </div>
    </>
  );
};
